<div *ngIf="showControl">
    <div *ngIf="!isCallbackRoute" class="ht-divider"><span class="ht-divider__label">or</span></div>

    <div class="gigya-login-container" *ngIf="!isCallbackRoute">
        <button type="submit" class="gigya-login-button" (click)="loginToGigya()"
            [disabled]="loggingIn || isAuthInProgress || !gigyaInitialized">
            <span *ngIf="!loggingIn && !isAuthInProgress">Sign in with Trek SSO</span>
            <span *ngIf="loggingIn || isAuthInProgress">Signing you in...</span>
        </button>

        <div class="error-message" *ngIf="error">
            <span>{{errorMessage}}</span>
        </div>
    </div>

    <div class="loading-container" *ngIf="isCallbackRoute">
        <p-progressSpinner strokeWidth="4" strokeColor="#ffffff" animationDuration=".5s"
            [style]="{ width: '50px', height: '50px' }"></p-progressSpinner>
    </div>
</div>